import { useState, useEffect } from "react";
import axios from "axios";
import { Globe2, MapPin, Facebook, Twitter, Music4, Youtube } from "lucide-react";
import { API } from "../constants";

const AffiliatesPage = () => {
  const [affiliates, setAffiliates] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAffiliates = async () => {
      try {
        const response = await axios.get(`${API}/affiliates`);
        setAffiliates(response.data);
      } catch (error) {
        console.error('Failed to load affiliates', error);
      }
      setLoading(false);
    };
    fetchAffiliates();
  }, []);

  return (
    <div className="min-h-screen bg-[#050505] pt-24">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="font-heading text-4xl sm:text-5xl tracking-wide mb-4">RECOMMENDED BUSINESSES</h1>
        <p className="text-gray-400 mb-8 max-w-2xl">
          This page is designed to highlight chrome shops, polishers, detailers, and other small businesses we trust. We can add or update these cards anytime with real partners, links, and locations.
        </p>

        {loading ? (
          <div className="text-gray-400">Loading affiliates...</div>
        ) : affiliates.length === 0 ? (
          <div className="text-gray-400">No affiliates added yet.</div>
        ) : (
          <div className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {affiliates.map((partner) => (
                <div key={partner.affiliate_id} className="bg-[#121212] border border-white/10 rounded-sm p-6 flex flex-col justify-between">
                  <div>
                    <h2 className="font-heading text-2xl mb-1">{partner.name}</h2>
                    <p className="text-[#D62828] text-sm mb-3">{partner.location}</p>
                    <p className="text-gray-300 text-sm mb-4">{partner.description}</p>
                  </div>
                  <div className="flex flex-wrap gap-3 text-xs mt-2">
                    {partner.links?.website && (
                      <a href={partner.links.website} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 px-3 py-2 bg-[#0A0A0A] border border-white/10 rounded-sm hover:border-[#D62828] transition-colors">
                        <Globe2 className="w-3 h-3" />Website
                      </a>
                    )}
                    {partner.links?.maps && (
                      <a href={partner.links.maps} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 px-3 py-2 bg-[#0A0A0A] border border-white/10 rounded-sm hover:border-[#D62828] transition-colors">
                        <MapPin className="w-3 h-3" />Maps
                      </a>
                    )}
                    {partner.links?.facebook && (
                      <a href={partner.links.facebook} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 px-3 py-2 bg-[#0A0A0A] border border-white/10 rounded-sm hover:border-[#1877F2] transition-colors">
                        <Facebook className="w-3 h-3" />Facebook
                      </a>
                    )}
                    {partner.links?.twitter && (
                      <a href={partner.links.twitter} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 px-3 py-2 bg-[#0A0A0A] border border-white/10 rounded-sm hover:border-[#1DA1F2] transition-colors">
                        <Twitter className="w-3 h-3" />Twitter
                      </a>
                    )}
                    {partner.links?.tiktok && (
                      <a href={partner.links.tiktok} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 px-3 py-2 bg-[#0A0A0A] border border-white/10 rounded-sm hover:border-white transition-colors">
                        <Music4 className="w-3 h-3" />TikTok
                      </a>
                    )}
                    {partner.links?.youtube && (
                      <a href={partner.links.youtube} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 px-3 py-2 bg-[#0A0A0A] border border-white/10 rounded-sm hover:border-[#FF0000] transition-colors">
                        <Youtube className="w-3 h-3" />YouTube
                      </a>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AffiliatesPage;
